/**
 * 
 * @param {HTMLElement} input - input element
 * @param {string | number} newValue - new value
 * @param {string} e - event name
 */
export default function dispatchEventToReact(input, newValue, e = "change") {
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    window[input.constructor.name].prototype || window.HTMLInputElement.prototype,
    "value"
  ).set
  nativeInputValueSetter.call(input, newValue)

  const ev2 = new Event(e, { bubbles: true })
  input.dispatchEvent(ev2)
}
